import { Type } from 'class-transformer';
import { Equals, IsIn, IsNumber, ValidateNested } from 'class-validator';

import { BaseRule } from './base-rule';
import { FilterType } from './consts';

export const NUMBER_COMPARATORS = ['>', '<', '>=', '<=', '==', '!='] as const;
export type NumberComparator = typeof NUMBER_COMPARATORS[number];

export class NumberRuleValue {
  @IsIn(NUMBER_COMPARATORS)
  comparator!: NumberComparator;

  @IsNumber()
  value!: number;
}

export class NumberRule extends BaseRule {
  constructor() {
    super();
    this.type = FilterType.NUMBER;
    this.value = {
      comparator: '==',
      value: 0,
    };
  }

  @Equals(FilterType.NUMBER)
  type: FilterType.NUMBER;

  @ValidateNested()
  @Type(() => NumberRuleValue)
  value: NumberRuleValue;
}
